// Customer-facing brand names; the catalog keeps its internal codes (e.g. "DW").
const BRAND_LABELS = { DW: 'Dongwon' };

export const brandLabel = (name) => BRAND_LABELS[name] || name;

// Server-side fabric search only knows the internal code, so map typed brand names back to it
export const brandSearchTerm = (q) => {
  const t = q.trim().toLowerCase();
  for (const [code, label] of Object.entries(BRAND_LABELS)) {
    const l = label.toLowerCase();
    if (t.length >= 3 && l.startsWith(t)) return code;
    if (t.startsWith(l)) return t.slice(l.length).replace(/^\s*(industry(\s+usa)?(\s+llc)?)?\s*/, '') || code;
  }
  return q;
};
